import { render } from "./Loading.vue?vue&type=template&id=26bfc3ec"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=26bfc3ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__